<template>
  <div>
    <navbar v-if="$route.meta.titleBar"></navbar>
    <app-main></app-main>
    <tabbar v-if="$route.meta.tabbar"></tabbar>
  </div>
</template>

<script>
import AppMain from './components/AppMain'
import Navbar from './components/Navbar'
import tabbar from './components/tabbar'
export default {
  name: 'StairLayout',
  data () {
    return {}
  },
  methods: {},
  mounted () {},
  created () {},
  components: {
    tabbar,
    AppMain,
    Navbar
  }
}
</script>

<style scoped lang='less'>

</style>
